import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { OutcomeCaseStudyArticle } from "@/components/resources/OutcomeCaseStudyArticle";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { articleJsonLdForPillar } from "@/components/site/PillarArticle";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import body from "../../content/resources/self-care-is-for-everyone-shopify-growth-case-study.en.md?raw";

const PATH = "/resources/self-care-is-for-everyone-growth-case-study";
const ALT = "/es/recursos/caso-self-care-is-for-everyone-crecimiento";
const TITLE = "Self-Care Is For Everyone: A Custom Shopify Store Built for Brand Growth";
const META_TITLE = "Self-Care Is For Everyone Shopify Case Study · Shugert";
const DESCRIPTION = "How Self-Care Is For Everyone rebuilt Shopify around brand launches, recording +42% collaboration-launch CVR and a 46% reduction in mobile LCP.";
const PUBLISHED = "2026-08-20T14:30:00.000Z";
const MODIFIED = "2026-08-20T14:30:00.000Z";

const SOURCES = [
  { label: "Shugert Marketing partner profile", publisher: "Shopify", href: "https://www.shopify.com/partners/directory/partner/shugert-marketing" },
  { label: "Self-Care Is For Everyone", publisher: "Self-Care Is For Everyone", href: "https://selfcareisforeveryone.com/" },
  { label: "Published project outcomes", publisher: "Shugert", href: "https://shugert.com.mx/work" },
  { label: "Largest Contentful Paint", publisher: "web.dev", href: "https://web.dev/articles/lcp" },
];

const RELATED = [
  { label: "Shopify performance", href: "/shopify-performance" },
  { label: "Shopify CRO", href: "/shopify-cro" },
  { label: "Shopify development", href: "/shopify-experts" },
  { label: "All Shopify case studies", href: "/work" },
];

export const Route = createFileRoute("/resources/self-care-is-for-everyone-growth-case-study")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "en", title: META_TITLE, description: DESCRIPTION, path: PATH, altPath: ALT, type: "article",
    author: "Samuel Noriega", articleAuthor: "Samuel Noriega", articleSection: "Shopify growth case study", publishedTime: PUBLISHED, modifiedTime: MODIFIED,
    jsonLd: [
      articleJsonLdForPillar({ title: TITLE, description: DESCRIPTION, path: PATH, publishedTime: PUBLISHED, modifiedTime: MODIFIED, section: "Shopify growth case study" }),
      breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Work", path: "/work" }, { name: "Self-Care Is For Everyone case study", path: PATH }]),
    ],
  }),
  component: () => (
    <SiteShell>
      <OutcomeCaseStudyArticle
        locale="en" path={PATH} title={TITLE}
        excerpt="How a mission-led brand moved from a legacy Shopify theme to a custom growth platform designed for high-visibility launches, faster mobile delivery, and repeatable campaign experiences."
        body={body} updated="August 2026" publishedAt={PUBLISHED} modifiedAt={MODIFIED} readingMinutes={10}
        focus="How custom storefront architecture, campaign UX, mobile performance, reusable launch components, and ongoing SEO supported a growing Shopify brand."
        audience="Shopify brands whose collaborations, drops, or campaign traffic have outgrown the constraints of a legacy theme and need measurable performance and conversion outcomes."
        sources={SOURCES} related={RELATED}
        category="Shopify growth & custom theme case study" backLabel="← Work" backHref="/work"
        cta={{ eyebrow: "Launch-ready Shopify", title: "Build the storefront for the next campaign, not only the current one.", body: "We scope custom Shopify builds around customer journeys, performance baselines, reusable launch workflows, and measurable commercial outcomes.", label: "Request a build scope", href: "/get-a-quote?intent=rebuild&source=self-care-case-study" }}
      />
    </SiteShell>
  ),
});
